import { Injectable } from '@angular/core';
export class LoggingService {
    title = 'LoggingService';
    loggingFunction = new Function();
constructor() {
    }
/**
 * @param {...?} args
 * @return {?}
 */
log(...args: any[]){
        this.loggingFunction(args);
    }
/**
 * @param {?} newLoggingFunction
 * @return {?}
 */
setLogginFunction(newLoggingFunction: Function){
        this.loggingFunction = newLoggingFunction;
    }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function LoggingService_tsickle_Closure_declarations() {
/** @type {?} */
LoggingService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LoggingService.ctorParameters;
/** @type {?} */
LoggingService.prototype.title;
/** @type {?} */
LoggingService.prototype.loggingFunction;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
